import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

async function update(axios: AxiosInstance, workshopUpdateRequestId: number, billable: boolean, status: number): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/workshop-update-request/${workshopUpdateRequestId}`, {
    billable: billable,
    status: status,
  });
  return data;
}

export default function useUpdateChargeForWorkshopUpdateRequestMutation() {
  const axios = useAxios();

  return useMutation({
    mutationFn: (params: { workshopUpdateRequestId: number; billable: boolean; status: number }) =>
      update(axios, params.workshopUpdateRequestId, params.billable, params.status),
  });
}
